import React from "react";
import {
  Box,
  Typography,
  Button,
  Zoom,
  Dialog,
  DialogContent,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

interface Props {
  open: boolean;
  onDashboardClick: () => void;
}

const SuccessStep: React.FC<Props> = ({ open, onDashboardClick }) => {
  return (
    <Dialog
      open={open}
      onClose={undefined}
      maxWidth={false}
      fullWidth={false}
      PaperProps={{
        sx: { borderRadius: "16px", width: "350px", height: "324" },
      }}
    >
      <DialogContent>
        <Zoom in={true} style={{ transitionDelay: "100ms" }}>
          <Box
            sx={{
              py: 2,
              px: 1,
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 2,
            }}
          >
            <Box
              sx={{
                width: 80,
                height: 80,
                borderRadius: "50%",
                backgroundColor: "#e8f5e9",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mb: 1,
              }}
            >
              <CheckCircleIcon sx={{ fontSize: 50, color: "#4caf50" }} />
            </Box>
            <Typography variant="h5" fontWeight={700} color="text.primary">
              You are in
            </Typography>
            <Typography variant="body2" sx={{ maxWidth: 300, mb: 2 }}>
              Your partner account has been created successfully. You can now
              start referring clients and earning commission.
            </Typography>
            <Button
              variant="contained"
              onClick={onDashboardClick}
              sx={{
                bgcolor: "#795548",
                color: "#fff",
                py: 1.5,
                px: 2,
                width: "200px",
                borderRadius: "50px",
                textTransform: "none",
                fontSize: "1rem",
                fontWeight: 600,
                "&:hover": { bgcolor: "#5d4037" },
              }}
            >
              Go to Dashboard
            </Button>
          </Box>
        </Zoom>
      </DialogContent>
    </Dialog>
  );
};

export default SuccessStep;
